import { render, staticRenderFns } from "./CrearDoctor.vue?vue&type=template&id=73cd1c6a"
import script from "./CrearDoctor.vue?vue&type=script&lang=js"
export * from "./CrearDoctor.vue?vue&type=script&lang=js"
import style0 from "./CrearDoctor.vue?vue&type=style&index=0&id=73cd1c6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports